import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  Rt
} from "./chunk.LTAMHVKK.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-collapsible/jb-collapsible.scss?inline
var jb_collapsible_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
label {
  font-family: var(--theme-font-black-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-black-weight, 900);
}

label {
  font-size: var(--theme-typo-uppercase-900-fontsize, 0.688rem);
  letter-spacing: var(--theme-typo-uppercase-900-letterspacing, 0.125rem);
  line-height: var(--theme-typo-uppercase-900-lineheight, 1rem);
  text-transform: uppercase;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
}

.holder {
  display: inline-flex;
  flex-direction: column;
  gap: 0;
  transition: 0.3s gap ease-in-out;
}
.holder.expandup {
  flex-direction: column-reverse;
}

.collapsible {
  display: none;
}
.collapsible + div > div {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease-in-out;
}
.collapsible + div > div > div {
  overflow: hidden;
}
.collapsible + div > div + label jb-chevron-icon {
  rotate: 90deg;
  transition: rotate 0.3s ease-in-out;
}
.collapsible:checked + div > div {
  grid-template-rows: 1fr;
}
.collapsible:checked + div > div + label jb-chevron-icon {
  rotate: -90deg;
}
.collapsible:checked + .holder {
  gap: var(--spacing-small);
}

label {
  align-items: center;
  border-block-end: 2px solid currentcolor;
  cursor: pointer;
  display: inline-flex;
  gap: var(--spacing-3xs);
  padding-block-end: var(--spacing-3xs);
  width: fit-content;
}`;

// src/components/jb-collapsible/jb-collapsible.ts
var JbCollapsible = class extends Spaceable(h) {
  constructor() {
    super(...arguments);
    this.buttonPosition = "top";
  }
  connectedCallback() {
    super.connectedCallback();
    this._elementId = "richtext_" + Math.floor(Math.random() * (999 - 100 + 1) + 100);
  }
  _getContentSpacingProperties() {
    return { type: "no-vertical-space" };
  }
  render() {
    return ke`<input
        type="checkbox"
        ?checked=${!this.isCollapsed}
        id="${this._elementId}"
        class="collapsible"
        @change=${(evt) => {
      this.isCollapsed = !evt.currentTarget.checked;
    }}
      />
      <div class="${Rt({ expandup: this.buttonPosition === "top" })} holder">
        <div>
          <div><slot></slot></div>
        </div>
        <label
          for="${this._elementId}"
          tabindex="0"
          @keypress=${(evt) => {
      evt.preventDefault();
      if (evt.code === "Space" || evt.code === "Enter") {
        this.isCollapsed = !this.isCollapsed;
      }
    }}
          >${this.isCollapsed ? this.toggleButtonTextOpen : this.toggleButtonTextClose}<jb-chevron-icon
          ></jb-chevron-icon
        ></label>
      </div>`;
  }
};
JbCollapsible.styles = r(jb_collapsible_default);
__decorateClass([
  n()
], JbCollapsible.prototype, "buttonPosition", 2);
__decorateClass([
  n({ type: Boolean })
], JbCollapsible.prototype, "isCollapsed", 2);
__decorateClass([
  n()
], JbCollapsible.prototype, "toggleButtonTextClose", 2);
__decorateClass([
  n()
], JbCollapsible.prototype, "toggleButtonTextOpen", 2);
__decorateClass([
  r2()
], JbCollapsible.prototype, "_elementId", 2);
JbCollapsible = __decorateClass([
  customElement("jb-collapsible")
], JbCollapsible);

export {
  JbCollapsible
};
